<template>
  <div class="slider">
    <div class="container">
      <div
        class="new-feature-announcement"
        data-aos="fade-down"
        data-aos-duration="800"
      >
        <span class="badge">NEW</span>
        <span class="text" style="line-height: 1"
          >Multi-Channel Messaging for Mirakl is here!</span
        >
        <a href="#messaging" class="learn-more" style="line-height: 1"
          >Learn more →</a
        >
      </div>

      <h1 data-aos="zoom-in" data-aos-duration="1000">
        <b>
          All in one Mirakl integration <br />
          for Linnworks & Veeqo sellers
        </b>
      </h1>

      <h4 data-aos="zoom-in" data-aos-delay="300" data-aos-duration="2000">
        Our Mirakl app for Linnworks & Veeqo is easiest way to <br />
        manage all your Mirakl marketplace business <br />
        in one place
      </h4>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Slider',
}
</script>

<style lang="scss" scoped>
.slider {
  background-image: url('../../assets/images/slider.jpg');
  background-position: center;
  background-size: cover;
  padding-bottom: 150px;
  @media (max-width: 1199px) {
    text-align: center;
  }

  .container {
    position: relative;
    flex-direction: row;
    margin: 0 auto;
  }

  .new-feature-announcement {
    display: inline-flex;
    align-items: center;
    gap: 12px;
    background: rgba(0, 0, 0, 0.6);
    backdrop-filter: blur(10px);
    border: 1px solid rgba(255, 140, 0, 0.5);
    border-radius: 50px;
    padding: 10px 20px;
    margin-top: 80px;
    margin-bottom: 20px;

    @media (max-width: 1199px) {
      flex-wrap: wrap;
      justify-content: center;
      margin-top: 70px;
    }

    .badge {
      background: darkorange;
      color: white;
      font-family: 'Open Sans', sans-serif;
      font-size: 11px;
      font-weight: bold;
      padding: 4px 10px;
      border-radius: 20px;
      letter-spacing: 1px;
      animation: pulse 2s infinite;
    }

    .text {
      font-family: 'Barlow', sans-serif;
      color: white;
      font-size: 16px;

      @media (max-width: 768px) {
        font-size: 14px;
      }
    }

    .learn-more {
      font-family: 'Open Sans', sans-serif;
      color: darkorange;
      font-size: 14px;
      font-weight: bold;
      text-decoration: none;
      transition: all 0.3s ease;

      &:hover {
        color: #ff9500;
        text-decoration: underline;
      }
    }
  }

  @keyframes pulse {
    0%,
    100% {
      opacity: 1;
      transform: scale(1);
    }
    50% {
      opacity: 0.8;
      transform: scale(1.05);
    }
  }

  h1,
  h4 {
    font-family: 'Barlow', sans-serif;
    color: white;
    text-shadow: 0 0 10px black;
    text-align: left;
    @media (max-width: 1199px) {
      text-align: center;
    }
  }

  h1 {
    font-size: 70px;
    padding-top: 20px;
  }

  h4 {
    font-size: 30px;
    padding-top: 30px;
  }
}
</style>
